var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "edit_photo",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 883.8 803.4",
    enableBackground: "new 0 0 883.8 803.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475,705l-18.6,71.4c-2.8,19.4,6.2,28.3,26.9,26.9l69.4-20.5L475,705 M220.5,366c-7.7-8.4-15.4-8.4-23,0 L2.5,593.2c3.6,26.9,13.8,51.1,30.8,72.6c0.4,0.5,0.8,1,1.2,1.4c1,2,2.2,3.8,3.8,5.6c2.7,3,5.1,5.6,7.3,7.8 c23.8,24,51.7,38.5,83.6,43.4l21.9,2c0.6,0,1.2,0.1,1.8,0.1h254.3l12.4-57.2l145.2-150.1L518.1,473c-7.6-7-15.1-7.2-22.5-0.6 l-104.3,99.2L220.5,366 M768.7,579.8c12.5-12.3,12.5-24.7,0-37l-56-56.1c-10.6-7.7-21.2-7.7-31.8,0L501.2,666.3l90.5,90.5 L768.7,579.8 M818.4,384.6c-10.6-7.7-21.2-7.7-31.9,0l-50.8,50.8l90.5,90.5l48.2-48.2c12.5-12.3,12.5-24.7,0-37L818.4,384.6  M726.9,173.2c0.1-1,0.1-2.1,0.1-3.1v-15c-0.1-35.9-10.8-67.5-32.1-94.7v-0.1c-3.6-4.5-7.9-9.3-12.9-14.5c-1.4-1.3-2.8-2.5-4.3-3.4 c-0.3-0.3-0.6-0.7-0.9-1c-3.3-3.1-6.5-5.8-9.5-8.1C639.7,11.2,607.7,0.2,571,0h-11c-0.5,0-1,0-1.5,0.1h-2.1c-0.5,0-1-0.1-1.5-0.1 H155c-0.2,0-0.3,0-0.5,0h-1.2c-35.5,0.6-66.7,11.7-93.6,33.2c-3.2,2.5-6.4,5.2-9.5,8.1c-0.3,0.3-0.7,0.7-1,1 c-1.5,1-2.9,2.1-4.2,3.4c-4.9,5-9.2,9.9-13,14.5v0.1C10.8,87.5,0.1,119.1,0,155v15c0,1.1,0.1,2.2,0.2,3.2c-0.1,1-0.2,2-0.2,3.1 v294.6l152.6-176.8c41.8-44.4,80.9-45.5,117.2-3.3l134.7,167.5l70.2-70.3c25.1-22,49-22,71.5,0l74.7,74.6l106.1-106V176.3 C727,175.2,727,174.2,726.9,173.2 M552.5,221.3c11.5,11.6,17.3,25.5,17.3,41.9c0,16.3-5.8,30.3-17.3,41.9 c-11.4,11.6-25.4,17.4-41.9,17.4c-16.3,0-30.3-5.8-41.9-17.4s-17.3-25.5-17.3-41.9c0-16.2,5.8-30.2,17.3-41.9 c11.6-11.5,25.6-17.3,41.9-17.3C526.9,204,540.9,209.8,552.5,221.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAPhotoIcon);
export default __webpack_public_path__ + "static/media/edit_a_photo_icon.0026a91e.svg";
export { ForwardRef as ReactComponent };